(ns ycweb.app.website.registry.thankyoumanager
  (:require
   [rum.core :as rum]
   [ycweb.app.website.common :as web-common]
   [ycweb.app.website.registry.common :as arm.cmn]
   [ycweb.app.website.website :as website]
   [ycweb.components.common :as cmn]
   [ycweb.components.feedback :as feedback]
   [ycweb.components.flow :as flow]
   [ycweb.components.forms :as input-forms]
   [ycweb.components.grid :as grid]
   [ycweb.components.headings :as headings]
   [ycweb.components.toaster :as toaster]
   [ycweb.components.transitions :as t]
   [ycweb.util.comms :as comms]
   [ycweb.util.core :as u]))

(rum/defc guest-purchase-item < rum/reactive [app-atom item]
  (let [{:client-order-item/keys [total-price price]
         :item-line/keys [variation product qty]} item
        {:product/keys [link]} product]
    [:tr.yc-tr
     [:td.yc-td.yc-td--product-image
      (web-common/lazy-image app-atom
        (:doc/public-id (:ent/image variation))
        {:class ["yc-td__image"]}
        {:w 100 :h 100 :c "pad"})]
     [:td.yc-td.yc-td--product-text
      [:a.block-link
       {:href
        link}]
      [:div.yc-td__product-name
       (:ent/display-name product)]]
     [:td.yc-td.yc-td--centered
      [:span.yc-td__faux-table
       {:data-th "Quantity"}
       [:span.yc-td__faux-td qty]]]
     [:td.yc-td
      [:span.yc-td__faux-table
       {:data-th "Price"}
       [:span.yc-td__faux-td (str "R" (u/currency-format price))]]]
     [:td.yc-td
      [:span.yc-td__faux-table
       {:data-th "Total"}
       [:span.yc-td__faux-td (str "R" (u/currency-format total-price))]]]]))

(rum/defcs guest-purchase < rum/reactive (rum/local {:show-details? false} ::state) [s app-atom order]
  (let [local-atom (::state s)
        {:keys [show-details?]} (rum/react local-atom)

        {:client-order/keys [delivery-details email items]
         :item-line/keys [user]} order

        guest-message (:registry/guest-message order)
        purchaser-name
        (or (:ent/display-name user) (:contact/name (:delivery/contact delivery-details)))]
    [:article.registry-buyer
     [:div.registry-buyer__header.js-registry-buyer-header
      [:h3.registry-buyer-title purchaser-name]
      [:ul.registry-buyer-contact
       [:li.registry-buyer-contact__item email]]
      [:nav.registry-buyer-nav
       [:a.button.button--raised.button--small.button--secondary.button--bordered
        {:on-click #(swap! local-atom assoc :show-details? (not show-details?))}
        (if show-details? "Hide Details" "Show details")]]]
     (when show-details?
       [:div.registry-buyer__details
        [:table.yc-table.yc-table--order-view
         [:caption.yc-table-caption.hidden-from-view
          (str "A summary of what " purchaser-name " bought for you.")]
         [:thead.yc-thead
          [:tr.yc-tr
           [:th.yc-th {:scope "col"} "Item"]
           [:th.yc-th {:scope "col"} "Description"]
           [:th.yc-th.yc-th--centered
            {:scope "col"}
            "Q" [:span.yc-table__clip-text "uanti"] "ty"]
           [:th.yc-th {:scope "col"} "Price"]
           [:th.yc-th {:scope "col"} "Total"]]]
         [:tbody.yc-tbod
          (map
            (fn [item]
              (rum/with-key
                (guest-purchase-item app-atom item)
                (str (:ent/uuid item))))
            items)

          (when guest-message
            [:tr.yc-tr
             [:td.yc-td
              {:colspan 5}
              (headings/heading "Gift Message:"
                {:type :h3
                 :size :tiny})
              [:p
               {:class (u/bem :yc-paragraph [:flush :small])}
               guest-message]]])]]])]))

(defmethod grid/action :web.registry/thank-you-manager.send-notifications [app-atom config _]
  (toaster/open-toast app-atom :processing "Saving" {:closetime 10000})
  (comms/ajax-post :web.registry/thank-you-manager.send-notifications config))

(defmethod comms/receive :web.registry/thank-you-manager.send-notifications
  [app-atom
   {:keys [success]
    :tracking/keys [active] :as tracking}]
  (toaster/close-toast app-atom)
  (cond
    success
    (toaster/open-toast app-atom :success "Saved" {:closetime 2000})

    :else
    (do
      (toaster/open-toast app-atom :error "Could not save preference" {:closetime 2000})
      (swap! (rum/cursor-in (cmn/process-cursor app-atom) [:registry])
        assoc
        (if (= (:tracking/type tracking) :email)
          :registry/email-tracking?
          :registry/dashboard-tracking?)
        active))))

(rum/defc registry-thank-you-manager < rum/reactive [app-atom]
  (let [process-atom (cmn/process-cursor app-atom)
        registry-atom (rum/cursor-in process-atom [:registry])
        {:registry/keys [dashboard-tracking?] :as registry} (rum/react registry-atom)
        guest-client-orders (cmn/curact process-atom [:guest-client-orders])
        guest-pending-purchases-count (cmn/curact process-atom [:pending-purchases-count])]
    [:<>
     (arm.cmn/registry-banner app-atom registry)
     (arm.cmn/registry-manage-nav app-atom :familydiscount registry)
     [:div
      {:class (u/bem :yc-section [(if dashboard-tracking? :standard-underline :medium)])}
      (headings/heading "Track Your Gift Purchases"
        {:type :h1
         :size :large
         :center true})
      [:div.u-block-center.u-max-width-480
       [:label.form-field.toggle-label
        {:for "emailtracking_toggle"}
        [:input.toggle
         (merge
           (input-forms/checkbox-props
             (rum/cursor-in registry-atom [:registry/email-tracking?])
             #(grid/dispatch-action app-atom :web.registry/thank-you-manager.send-notifications
                {:tracking/type :email
                 :tracking/active? (:registry/email-tracking? @registry-atom)
                 :registry/uuid (str (:ent/uuid registry))})
             nil
             false
             false)
           {:id "emailtracking_toggle"})]
        [:span.toggle__graphic-wrapper
         [:span.toggle__graphic]]
        [:span.toggle__text
         [:span.toggle__title "Receive email notifications"]
         [:span.toggle__description
          "We'll send you real-time email notifications when someone buys you a gift."]]]

       [:label.form-field.toggle-label
        {:for "dashboardtracking_toggle"}
        [:input.toggle
         (merge
           (input-forms/checkbox-props
             (rum/cursor-in registry-atom [:registry/dashboard-tracking?])
             #(grid/dispatch-action app-atom :web.registry/thank-you-manager.send-notifications
                {:tracking/type :dashboard
                 :tracking/active? (:registry/dashboard-tracking? @registry-atom)
                 :registry/uuid (str (:ent/uuid registry))})
             nil
             false
             false)
           {:id "dashboardtracking_toggle"})]
        [:span.toggle__graphic-wrapper
         [:span.toggle__graphic]]
        [:span.toggle__text
         [:span.toggle__title "Show dashboard notifications"]
         [:span.toggle__description
          "We'll show you a list of who's bought you a gift below, and you'll have the option to show details of what they've bought."]]]]]
     (when dashboard-tracking?
       [:div.yc-section.yc-section--large
        (headings/heading
          [:span "Who purchased gifts" [:span.clip-text.unclip-text--m " off your Registry"]]
          {:type :h2
           :size :small
           :center true
           :subtext
           (when (pos? guest-pending-purchases-count)
             (list (str guest-pending-purchases-count)
               (if (= guest-pending-purchases-count 1)
                 " item is"
                 " items are")
               " currently in your guests' carts."))})

        (cond
          (not (empty? guest-client-orders))
          (map
            (fn [guest-client-order]
              (rum/with-key
                (guest-purchase app-atom guest-client-order)
                (str (:ent/uuid guest-client-order))))
            guest-client-orders)

          :else
          [:div.u-max-width-720.u-block-center
           (feedback/feedback-raw :info
             {:title "No gifts have been purchased yet."
              :description "We'll update this list as soon as one of your guests has bought a gift for you."
              :size :small})])])
     (toaster/loading-overlay app-atom :web.registry/thankyoumanager)]))

(defmethod flow/render-screen :web.registry/thankyoumanager [app-atom _]
  (website/screen-wrapper app-atom
    (registry-thank-you-manager app-atom)
    {:pagetype :registry}))

(defmethod t/transition-open :web.registry/thankyoumanager [app-atom _ params]
  (toaster/open-overlay app-atom :web.registry/thankyoumanager)
  (comms/ajax-get :web.registry/thank-you-manager (select-keys params [:uuid])))

(defmethod comms/receive :web.registry/thank-you-manager
  [app-atom {:keys [registry guest-client-orders pending-purchases]}]
  (swap! (cmn/process-cursor app-atom) assoc
    :guest-client-orders guest-client-orders
    :registry registry
    :pending-purchases-count pending-purchases)
  (toaster/close-overlay app-atom :web.registry/thankyoumanager))